<template>
  <div v-if="isShowBlock" :class="[$style.infoPageTextBlock, $style[`infoPage__${data.theme}`]]">
    <Markdown
      :text="textWithMirrorBody"
      :auto-link-parse="data.autoLinkFormat"
      :is-link-new-page-open="data.linksNewPage"
      :class="$style.infoPageTextBlockStrapi"
    />
  </div>
</template>

<script lang="ts" setup>
import Markdown from '~/components/markdown.vue';
import { useStoreRoot } from '~/stores/abstract/root';
import { useStoreSsPlayer } from '~/stores/softswiss/player';
import type { ComponentInfoPageBlocksTextBlock } from '~/types/infoPages';

const props = defineProps({
  data: {
    type: Object as PropType<ComponentInfoPageBlocksTextBlock>,
    required: true,
  },
});

const storeSsPlayer = useStoreSsPlayer();

const isShowBlock = computed(() => {
  if (props.data && !storeSsPlayer.isPlayerDataLoadingFirstInitOnce) {
    return true;
  }
  if (props.data && props.data.showForAuthorized === false) {
    return !storeSsPlayer.isPlayerAuthorised;
  } else if (props.data) {
    return true;
  }
  return false;
});

const textWithMirrorBody = computed(() => {
  const geo = useStoreRoot().geo;

  if (geo && geo !== 'main') {
    const mirrorBody = props.data.mirrorBody?.find((body) => body?.geo === geo);

    if (mirrorBody) {
      return mirrorBody.descriptionText;
    }
  }
  return props.data.text;
});
</script>

<style lang="scss" module src="./textBlock.scss"></style>
